import React, { useEffect, useState } from "react"

import { Alert, Card, Col, Row, Layout } from "antd"
import { css } from "@emotion/css";
import HeaderMenu from "./components/HeaderMenu";

export default function AdobeProd() {
    return (
      <Layout>
        <Layout.Header className={css`
          background-color: #ffffff !important;
          display: flex;
          align-items: center;
          padding-inline: unset !important;
        `}>
            <div className={css`
            margin-left: 30px;
            margin-right: 15px;
            display: flex;
            flex-direction: column;
            align-items: center;
            border-right: 1px solid #dddddd;
            padding-right: 15px;
            `}>
                <img src="/6sense-logo.svg" className={css`
                    width: 82px;
                    height: 22px;
                `} />
                <span className={css`
                    line-height: 14px !important;
                    margin-top: 8px;
                    font-family: 'FiraCodeLight', 'Open Sans', monospace;
                `}>SFF Demo Site</span>
            </div>
                
                <HeaderMenu current={'adobeprod'} />
                <span className={css`
                margin-right: 30px;
                color: red;
                font-size: 16px;
                font-family: 'FiraCode', monospace;
                `}>
                    Internal Usage Only - Integrations Team
                </span>
            </Layout.Header>
            <div className={css`padding: 15px;`}>
              <Row gutter={6}>
                  <Col>
                      <Card title="Adobe Loader">
                          <AdobeProdLoader  />
                      </Card>
                  </Col>
              </Row>
            </div>
            <Layout.Content>
                Adobe
            </Layout.Content>
        </Layout>
    );
}
declare global {
    interface Window {
        _6si: any;
    }
}

enum TagState {
    Loading,
    Loaded,
    Error
}

function AdobeProdLoader() {
    const [tagState, setTagState] = useState(TagState.Loading);
    useEffect(() => {
        if((window as any).loadedTag) {
            return
        } else {
            (window as any).loadedTag = true;
        }
        (function () {
            var a = document.createElement("script");
            a.async = !0;
            a.src = `https://assets.adobedtm.com/88862feaf93a/b3953a97fdbe/launch-b43c0ae0833f.min.js`;
            a.onload = () => {
                console.log('adobe extension loaded');
                setTagState(TagState.Loaded);
            }
            a.onerror = () => {
                setTagState(TagState.Error);
            }
            var b = document.getElementsByTagName("script")[0]; b.parentNode?.insertBefore(a, b)
        }
        )();
    }, [false])
    return (<>
        {tagState == TagState.Loading && <>Loading Adobe Tag on Page: </>}
        {tagState == TagState.Loaded && <Alert message="Adobe Tag JS Loaded from Worker" type="success" />}
        {tagState == TagState.Error && <Alert message="Adobe Tag JS Failed to Load" type="error" />}
    </>);
}
